"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filtersReducer = void 0;
const filters_1 = require("../actions/filters");
const initState = [];
const filtersReducer = (filterItems = initState, action) => {
    switch (action.type) {
        case filters_1.SET_FILTER_ITEMS:
            return [...action.payload];
        default:
            return filterItems;
    }
};
exports.filtersReducer = filtersReducer;
//# sourceMappingURL=filters.reducer.js.map